<script>
import toastr from "toastr";
export default {
  name: "navDashboard",
  data: () => ({
    version: process.env.VUE_APP_VERSION,
    nameApp: process.env.VUE_APP_NAME,
  }),
  methods: {
    logout() {
      this.$store
        .dispatch("destroyToken")
        .then(() => {
          window.location.href = "/";
        })
        .catch(() => {
          toastr.error("Error al cerrar sesión");
        });
    },
  },
};
</script>
<template>
  <div class="navbar fixed-top">
    <div class="d-flex flex-row logo-version" style="align-items: center">
      <div class="logo">
        <img
          src="/img/logo.png"
          alt=""
          class="img-fluid"
          style="width: 170px"
        />
      </div>
      <div class="nameView lg">
        <div class="d-flex flex-column">
          <strong
            style="font-weight: 500; text-transform: uppercase; font-size: 15px"
            >Missing Calls {{ nameApp }} -
            <small style="text-transform: lowercase">v</small
            >{{ version }}</strong
          >
          <small style="font-size: 12px"
            >Gestión de llamadas no atendidas en sistemas Rapport</small
          >
        </div>
      </div>
    </div>

    <div
      class="menu-user d-flex flex-row"
      style="align-items: center; gap: 15px"
    >
      <div class="nombre-user lg" style="font-weight: 600">
        {{ $store.state.user.name }}
      </div>

      <div class="dropdown">
        <div
          style="box-shadow: none !important"
          class="avatar d-flex"
          type="button"
          data-toggle="dropdown"
          aria-expanded="false"
        >
          <svg
            style="color: #a4a4a4; width: 39px"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            class="size-6"
          >
            <path
              fill-rule="evenodd"
              d="M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <div
          class="dropdown-menu"
          style="position: absolute; left: -103px !important; border: none !important;"
        >
          <a
            @click.prevent="logout()"
            class="dropdown-item d-flex flex-row gap-3"
            style="text-align: left; padding: 9px; color: #333; align-items: center;"
            href="#"
          >
            <svg
              style="width: 15px; color:red"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="size-6"
            >
              <path
                fill-rule="evenodd"
                d="M16.5 3.75a1.5 1.5 0 0 1 1.5 1.5v13.5a1.5 1.5 0 0 1-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V15a.75.75 0 0 0-1.5 0v3.75a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V5.25a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3V9A.75.75 0 1 0 9 9V5.25a1.5 1.5 0 0 1 1.5-1.5h6Zm-5.03 4.72a.75.75 0 0 0 0 1.06l1.72 1.72H2.25a.75.75 0 0 0 0 1.5h10.94l-1.72 1.72a.75.75 0 1 0 1.06 1.06l3-3a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 0 0-1.06 0Z"
                clip-rule="evenodd"
              />
            </svg>

            <div>Cerrar Sesión</div></a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.logo-version {
  gap: 5rem;
}
.navbar {
  background: white;
  padding-inline: 24px;
  justify-content: space-between;
  box-shadow: 0px 4px 30px 3px #0000000d;
}
@media (max-width: 768px) {
  .nav {
    padding-left: 23px !important;
    padding-right: 23px !important;
  }
}
.nav {
  z-index: 1000;
  align-items: center;
  padding-left: 79px;
  padding-right: 79px;
  position: fixed;
  background: white;
  width: 100%;
  left: 0;
  right: 0;
  top: 0;
  height: 57px;
  border-bottom: 1px solid #e5e5e5;
  .nameView {
    margin-left: 81px;
    font-size: 16px;
    font-weight: 700;
    color: #767676;
  }

  .menu-user {
    margin-right: 10px;

    .dropdown-menu {
      position: absolute;
      will-change: transform;
      padding: 13px;
      text-align: left;
      width: 185px;
      top: 0px;
      left: -76px !important;
      transform: translate3d(-58px, 48px, 0px);
    }

    .nombre-user {
      margin-right: 10px;
      font-size: 13px;
      font-weight: 800;
      color: #6b6b6b;
      text-transform: uppercase;
    }

    .dropdown-item:active {
      background: rgb(228, 228, 228) !important;
    }

    .avatar {
      cursor: pointer;
      justify-content: center;
      align-items: center;
      height: 40px !important;
      width: 40px !important;
      color: #333;
      font-weight: bold;
      font-size: 20px;
      box-shadow: none !important;
    }
  }
}
</style>
